
export const residentialCC = [
    {
      title: 'Certificate Number',
      dataIndex: 'certificateNumber',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.certificateNumber.localeCompare(b.certificateNumber),
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.customerName.localeCompare(b.customerName),
    },
    {
      title: 'MSSL',
      dataIndex: 'mssl',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.mssl.localeCompare(b.mssl),
    },
    {
      title: 'Geneco Account Number',
      dataIndex: 'accountNo',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
    },
    {
      title: 'Contract Number',
      dataIndex: 'contractNumber',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.contractNumber.localeCompare(b.contractNumber),
    },
    {
      title: 'Product Name',
      dataIndex: 'productName',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.productName.localeCompare(b.productName),
    },
    {
      title: 'Certificate Issuance Date',
      dataIndex: 'createdDate',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      editable: true,
      sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      editable: true,
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    {
      title: 'Total Quantity(kgCO2e)/(kWh)',
      dataIndex: 'totalQuantity',
      editable: true,
      sorter: (a, b) => a.totalQuantity - b.totalQuantity,
    },
    {
      title: 'Certificate',
      dataIndex: 'certificateUrl',
      editable: true,
      render:(record)=><a href={record} target="_blank" rel="noreferrer">Link</a>
    },
    {
      title: 'Notification Email Sent To',
      dataIndex: 'emailAddress',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.notifiedEmail.localeCompare(b.notifiedEmail),
    },
  ]

  export const businessCC = [
    {
      title: 'Certificate Number',
      dataIndex: 'certificateNumber',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.certificateNumber.localeCompare(b.certificateNumber),
    },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.customerName.localeCompare(b.customerName),
    },
    {
      title: 'MSSL',
      dataIndex: 'mssl',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.mssl.localeCompare(b.mssl),
    },
    {
      title: 'Business Registration No.',
      dataIndex: 'accountNo',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
    },
    {
      title: 'Contract Number',
      dataIndex: 'contractNumber',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.contractNumber.localeCompare(b.contractNumber),
    },
    {
      title: 'Product Name',
      dataIndex: 'productName',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.productName.localeCompare(b.productName),
    },
    {
      title: 'Certificate Issuance Date',
      dataIndex: 'createdDate',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      editable: true,
      sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      editable: true,
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    {
      title: 'Total Quantity(kgCO2e)/(kWh)',
      dataIndex: 'totalQuantity',
      editable: true,
      sorter: (a, b) => a.totalQuantity - b.totalQuantity,
    },
    {
      title: 'Certificate',
      dataIndex: 'certificateUrl',
      editable: true,
      render:(record)=><a href={record} target="_blank" rel="noreferrer">Link</a>
    },
    {
      title: 'Notification Email Sent To',
      dataIndex: 'emailAddress',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.notifiedEmail.localeCompare(b.notifiedEmail),
    },
  ]

  export const residentialRerun = [
    {
        title: 'Table Operation',
        dataIndex: 'operation',
        editable: false,
      },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.customerName.localeCompare(b.customerName),
    },
    {
      title: 'MSSL',
      dataIndex: 'mssl',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.mssl.localeCompare(b.mssl),
    },
    {
      title: 'Geneco Account Number',
      dataIndex: 'accountNo',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
    },
    {
      title: 'Contract Number',
      dataIndex: 'contractNumber',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.contractNumber.localeCompare(b.contractNumber),
    },
    {
      title: 'Product Name',
      dataIndex: 'productName',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.productName.localeCompare(b.productName),
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      editable: true,
      sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      editable: true,
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    {
      title: 'Total Quantity(kgCO2e)/(kWh)',
      dataIndex: 'totalQuantity',
      editable: true,
      sorter: (a, b) => a.totalQuantity - b.totalQuantity,
    },
  ]

  export const businessRerun = [
    {
        title: 'Table Operation',
        dataIndex: 'operation',
        editable: false,
      },
    {
      title: 'Customer Name',
      dataIndex: 'customerName',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.customerName.localeCompare(b.customerName),
    },
    {
      title: 'MSSL',
      dataIndex: 'mssl',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.mssl.localeCompare(b.mssl),
    },
    {
      title: 'Business Registration Number',
      dataIndex: 'accountNo',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.accountNo.localeCompare(b.accountNo),
    },
    {
      title: 'Contract Number',
      dataIndex: 'contractNumber',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.contractNumber.localeCompare(b.contractNumber),
    },
    {
      title: 'Product Name',
      dataIndex: 'productName',
      editable: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: (a, b) => a.productName.localeCompare(b.productName),
    },
    {
      title: 'Start Date',
      dataIndex: 'startDate',
      editable: true,
      sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
    },
    {
      title: 'End Date',
      dataIndex: 'endDate',
      editable: true,
      sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
    },
    {
      title: 'Total Quantity(kgCO2e)/(kWh)',
      dataIndex: 'totalQuantity',
      editable: true,
      sorter: (a, b) => a.totalQuantity - b.totalQuantity,
    },
  ]